import React from 'react';

import { formatMoney, toMoney } from '@betterment/core';
import { TabularNumber } from '@betterment/style-closet-react';

import { DetailedTransaction, TransactionStatus } from '../../data';

type TransactionAmountProps = Pick<DetailedTransaction, 'status' | 'isCredit' | 'amountCents'>;

const TransactionAmount: React.FC<React.PropsWithChildren<TransactionAmountProps>> = ({
  status,
  isCredit,
  amountCents,
}) => {
  const formattedAmount = amountCents == null ? 'Pending' : formatMoney(toMoney(amountCents));
  const prefix = amountCents != null && !isCredit ? '-' : '';

  let color = 'bmtGrey90';
  if (status === TransactionStatus.Voided) {
    color = 'bmtGrey50';
  } else if (isCredit) {
    color = 'bmtTeal90';
  }

  const shouldStrikeThrough = status === TransactionStatus.Voided;

  return (
    <TabularNumber textAlign="right" color={color} textDecoration={shouldStrikeThrough ? 'line-through' : 'inherit'}>
      {prefix}
      {formattedAmount}
    </TabularNumber>
  );
};

export default TransactionAmount;
